export { default as OrdenesListar } from './Listar'
export { default as OrdenesCrear } from './Crear'
export {default as OrdenDetalle} from './Detalle'